<div class="flex flex-wrap sm:flex-nowrap items-center">
  <div class="flex justify-between items-start flex-wrap w-full">
    <!--begin::Details-->
    <div class="flex flex-col">
      <!--begin::Status-->
      <div class="flex items-end mb-1">
        <h5 class="text-gray-700! font-medium"
          >{{"DASHBOARD_COASSESS.TPA_MANAGEMENT" | translate}}</h5
        >
      </div>
      <!--end::Status-->

      <!--begin::Description-->
      <div class="flex flex-wrap font-semibold mb-6 text-gray-400">
        {{"DASHBOARD_COASSESS.HEADER" | translate}}
      </div>
      <!--end::Description-->
    </div>
    <!-- <div class="flex mb-6">
      <button pButton routerLink="/manage-users" class="mr-3">
        {{"DASHBOARD_COASSESS.VIEW_USERS" | translate}}
      </button>

      <button pButton [severity]="'success'" routerLink="/case-table" class="mr-3">
        {{"DASHBOARD_COASSESS.VIEW_CLAIMS" | translate}}
      </button>
    </div> -->
  </div>
</div>
